import React, { useState } from 'react';
import { IconButton, Tooltip, Box, Modal } from '@mui/material';
import { Edit, Download, X, Factory } from 'lucide-react';
import { format } from 'date-fns';
import Scope3ReviewModal from './Scope3ReviewModal';

const DocumentCard = ({ document, refetch }) => {
  const [isFileUploadModalOpen, setIsFileModalOpen] = useState(false);

  const downloadFile = (filePath) => {
    window.open(filePath, '_blank');
  };

  const getStatusLabel = () => {
    if (document.review_done === 1) {
      return { label: 'Review Done', color: 'bg-green-100 text-green-700' };
    }

    if (document.review_file_name && document.review_file_name !== 'NULL' || document.co2_emission_tonnes && document.co2_emission_tonnes !== 'NULL') {
      return { label: 'Under Review', color: 'bg-yellow-200 text-yellow-700' };
    }

    if (document.send_for_review === 1) {
      return { label: 'Available For Review', color: 'bg-gray-200 text-black' };
    }

    if ((!document.file_name || document.file_name === 'NULL') && (!document.co2_emission_tonnes || document.co2_emission_tonnes === 'NULL')) {
      return { label: 'Data Unavailable', color: 'bg-gray-100 text-gray-600' };
    }

    if (document.send_for_review != 1) {
      return { label: 'Unavailable For Review', color: 'bg-gray-100 text-gray-600' };
    }

    return { label: 'Not Reviewed', color: 'bg-gray-100 text-gray-600' };
  };


  const status = getStatusLabel();

  return (
    <div className="border border-gray-200 rounded-2xl p-5 shadow-sm bg-gradient-to-br from-white to-gray-50 flex flex-col gap-4 transition hover:shadow-lg hover:scale-[1.01] duration-200">

      {/* Date & Status */}
      <div className="flex justify-between items-center text-sm">
        <span className="text-gray-500" title='sent for review on'>
          {document.send_for_review_at ? format(document.send_for_review_at, 'dd MMM yyyy') : '-- --- ----'}
        </span>
        <span className={`px-2 py-1 text-xs font-semibold rounded-full ${status.color}`}>
          {status.label}
        </span>
      </div>

      {/* File Name */}
      <div
        className="font-bold text-lg text-gray-800 truncate cursor-pointer hover:underline"
        title={document.file_name}
        onClick={() => downloadFile(document.file_path)}
      >
        📄 {document.file_name}
      </div>

      {/* Category */}
      <div className="text-sm text-green-700 font-medium bg-green-50 px-3 py-1 rounded-md w-fit">
        {document.cat_no} - {document.cat_title}
      </div>

      {/* Option Selected */}
      <div className="text-sm text-gray-700 italic px-2">{document.option_selected}</div>

      {/* Emission Section - Improved */}
      <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 mt-2">
        <div className="bg-green-100 text-green-700 p-2 rounded-full">
          <Factory className="w-5 h-5" />
        </div>
        <div>
          <div className="text-xs text-gray-500 uppercase tracking-wider font-semibold">Total Emission</div>
          <div className="text-lg font-semibold text-gray-800">
            {document.co2_emission_tonnes ?? '—'} <span className="text-sm text-gray-600">tCO₂e</span>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="flex justify-end gap-3 mt-2">
        <Tooltip title="Download File">
          <IconButton size="medium" className="hover:text-blue-600" onClick={() => downloadFile(document.file_path)}>
            <Download className="w-5 h-5" />
          </IconButton>
        </Tooltip>
        {/* {(getStatusLabel().label === 'Available For Review' || getStatusLabel().label === 'Review Done' || getStatusLabel().label === 'Under Review')  && (
        <Tooltip title="Review File">
          <IconButton size="medium" className="hover:text-blue-600" onClick={() => setIsFileModalOpen(true)}>
            <Edit className="w-5 h-5" />
          </IconButton>
        </Tooltip>
        )} */}
        <Tooltip title="Review File">
          <IconButton
            size="medium"
            className="hover:text-blue-600"
            onClick={() => setIsFileModalOpen(true)}
            disabled={
              !['Available For Review', 'Review Done', 'Under Review'].includes(getStatusLabel().label)
            }
          >
            <Edit className="w-5 h-5" />
          </IconButton>
        </Tooltip>
      </div>

      {/* Modal */}
      <Modal
        open={isFileUploadModalOpen}
        onClose={() => setIsFileModalOpen(false)}
        aria-labelledby="review-modal-title"
        aria-describedby="review-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            maxWidth: '90vw',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: '12px',
            position: 'relative',
          }}
        >
          <button
            onClick={() => setIsFileModalOpen(false)}
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            aria-label="Close"
          >
            <X size={24} />
          </button>
          <Scope3ReviewModal
            data={document}
            handleCloseMainDetailModal={() => setIsFileModalOpen(false)}
            refetch={refetch}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default DocumentCard;
